import { render } from "./TheModalProduct.vue?vue&type=template&id=1519bc86&scoped=true&lang=pug&bindings={\"id\":\"props\",\"product\":\"setup\",\"lang\":\"setup\",\"res\":\"setup\"}"
import script from "./TheModalProduct.vue?vue&type=script&lang=js"
export * from "./TheModalProduct.vue?vue&type=script&lang=js"

import "./TheModalProduct.vue?vue&type=style&index=0&id=1519bc86&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1519bc86"

export default script